import React, { Component } from 'react'
// 样式
import './index.less'
// 仓库
import { inject, observer } from 'src/core/store'
// 工具
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
// 语言适配
import { getlangV2, setlang } from 'src/helper/getlang'
import langM from './lang'

// 文本提示
import Toast from '../../../component/Toast'
// 弹窗禁止滑动
import forbidScroll from 'src/tools/forbidScroll'
// 滑动组件
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper-bundle.min.css'
// 跳转用户、房间
// 弹窗组件
import ReminderBtn from 'src/component/RuleButton'
import debounce from 'lodash/debounce'

@inject('store')
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    setDocumentTitle('Ruby')
    this.ruby = this.props.store.register('app/ruby')
    this.rubyMore = debounce(this.rubyMore, 500)
    this.onDrawMore = debounce(this.onDrawMore, 500)
    this.onDrawMoreFamily = debounce(this.onDrawMoreFamily, 500)
  }

  state = {
    userRubyInfo: {},
    lang: langM.ar,
    isPopUp: false,
    isHandle: false,
    tabState: 1,
    swiperObj: null,
    rubyNum: 0,
    receiveRubyToCoins: 0, //总宝石数
    freezeRuby: 0,
    isHostSystem: 0,
    exchangeNum: 0,

    rubyList: [],

    // 等级列表
    withdrawalLvList: [],

    // 用户当前在线时长
    userOnTime: 0,

    familyWithdrawalList: [],
    userWithdrawalList: [],

    desc: '',
    familyLeaderInfo: {},
    familyId: 0,
    drawNum: 0,

    handleDrawId: 0,

    rubyMore: false,
    rubyScroll: '',

    drawMore: false,
    drawScroll: '',

    familyMore: false,
    familyScroll: '',

    canEx: true,
    isLoading: false,
    isLoadingDraw: false,
    isLoadingDrawFamily: false,
    isShowWithdrawal: false,
    isShowTitle: false,
    changNum: 0,
    canChang:true,// 可以转换
    language:'en',
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlangV2(language, langM)
    console.log('language', language)
    // lang 文字对象
    // language 语言种类 (zh/ar/en)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    let uid = await setUidToken(this.props.location.query)
    this.setState({
      uid: uid
    })
    console.log(uid, 'uid')
    let res = await this.ruby.GetUserInfoWeb(uid)
    if (res.hostsystemId>0) {
      this.setState({canChang:true})
    }else{
      this.setState({canChang:false})
    }
    await this.RunOnStart(uid)
     
     this.setState({
      rubyNum: res && res.ruby,
      receiveRubyToCoins: res && res.receiveRubyToCoins,//每月
      freezeRuby: res && res.freezeRuby,
      isHostSystem: res && res.host,
      userRubyInfo: res,
      receiveRuby:res.receiveRuby,//总宝石
    })
    
  }

  // 初始化用户 - 红宝石/冻结红宝石/是否拥有host
  async initUserInfo() {
    let info = await this.ruby.userRubyInfo()
    console.log(info, '初始化 info')
    this.setState({
      rubyNum: info && info.ruby,
      receiveRubyToCoins: info && info.receiveRubyToCoins,
      freezeRuby: info && info.freezeRuby,
      isHostSystem: info && info.host,
      userRubyInfo: info,
      receiveRuby:info.receiveRuby,
    })
  }

  // 初始化红宝石兑换金币列表
  async initRubyMoreList() {
    let rubyList = await this.ruby.rubyExchangeList()
    console.log(rubyList, '初始化 rubyList')
    this.setState({
      rubyList: rubyList && rubyList.list,
      rubyMore: rubyList && rubyList.hasMore,
      rubyScroll: rubyList && rubyList.scroll
    })
  }

  // 初始化提现等级列表
  async initWithdrawalLevel() {
    let withdrawalLvList = await this.ruby.getWithdrawalLvList()
    console.log(withdrawalLvList, '初始化 withdrawalLvList')
    withdrawalLvList &&
      withdrawalLvList.list.map((item, index) => {
        item.grade = String.fromCharCode(index + 65)
      })
    this.setState({
      withdrawalLvList: withdrawalLvList && withdrawalLvList.list,
      userOnTime: withdrawalLvList && withdrawalLvList.onMicTime
    })
  }

  // 初始化家族信息
  async initFamilyInfo() {
    // 家族信息
    let familyInfo = await this.ruby.familyInfo()
    console.log(familyInfo, '初始化 familyInfo')
    this.setState({
      // 家族ID
      familyId: familyInfo && familyInfo.info && familyInfo.info.familyId,
      // 家族族长信息
      familyLeaderInfo: familyInfo && familyInfo.info && familyInfo.info.ownerUserInfo,
      isShowWithdrawal: familyInfo && familyInfo.info && familyInfo.info.withdrawal
    })
  }

  // 初始化提现列表
  async initUserWithdrawalList() {
    // 提现列表
    let userWithdrawalList = await this.ruby.userWithdrawalList()
    this.setState({
      userWithdrawalList: userWithdrawalList && userWithdrawalList.res && userWithdrawalList.res.list,
      // 提现列表更多参数
      drawMore: userWithdrawalList && userWithdrawalList.res && userWithdrawalList.res.hasMore,
      drawScroll: userWithdrawalList && userWithdrawalList.res && userWithdrawalList.res.scroll
    })
    console.log(this.state.drawMore,userWithdrawalList)
  }

  // 初始化家族提现列表
  async initFamilyWithdrawalList() {
    // 家族列表
    let familyWithdrawalList = await this.ruby.familyWithdrawalList({ familyId: this.state.familyId })
    this.setState({
      familyWithdrawalList: familyWithdrawalList && familyWithdrawalList.res && familyWithdrawalList.res.list,
      // 家族提现列表更多参数
      familyMore: familyWithdrawalList && familyWithdrawalList.res && familyWithdrawalList.res.hasMore,
      familyScroll: familyWithdrawalList && familyWithdrawalList.res && familyWithdrawalList.res.scroll
    })
  }

  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    // 用户id
    this.setState({
      uid: uid
    })

    await this.initUserInfo()
    await this.initFamilyInfo()

    await this.initWithdrawalLevel()
    await this.initRubyMoreList()
    await this.initUserWithdrawalList()
    await this.initFamilyWithdrawalList()
  }

  componentDidMount() {
    // 下拉加载更多
    document.addEventListener('scroll', () => {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 滚动条距离顶部的距离
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight // 可视区的高度
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight //dom元素的高度，包含溢出不可见的内容
      console.log(131)
      if (scrollHeight - scrollTop <= windowHeight + 30) {
        if (this.state.tabState == 1) {
          if (this.state.rubyMore) {
            this.setState({
              isLoading: true
            })
            this.rubyMore()
          }
        }
        if (this.state.tabState == 2) {
          if (this.state.drawMore) {
            this.setState({
              isLoadingDraw: true
            })
            this.onDrawMore()
          }
        }
        if (this.state.tabState == 3) {
          if (this.state.familyMore) {
            this.setState({
              isLoadingDrawFamily: true
            })
            this.onDrawMoreFamily()
          }
        }
      }
    })
  }

  // 弹窗
  onChangeDrawPopUp(bool) {
    forbidScroll(bool)
    this.setState({
      isPopUp: bool
    })
  }
  onChangeHandlePopUp(bool, id) {
    forbidScroll(bool)
    this.setState({
      isHandle: bool,
      handleDrawId: id
    })
  }

  // 条件：在线时长验证
  gradeVerify() {
    const ontime = this.state.userOnTime
    if (ontime >= 0 && ontime < 32) {
      this.setState({
        desc: this.state.lang.noTime
      })
      this.refs.toast.hideRule(true)
    }
    if (ontime >= 32 && ontime < 40) {
      if (this.state.drawNum >= 400000) {
        return true
      } else {
        this.setState({
          desc: this.state.lang.greaterThan(400000)
        })
        this.refs.toast.hideRule(true)
        return false
      }
    }

    if (ontime >= 40 && ontime < 50) {
      if (this.state.drawNum >= 200000) {
        return true
      } else {
        this.setState({
          desc: this.state.lang.greaterThan(200000)
        })
        this.refs.toast.hideRule(true)
        return false
      }
    }

    if (ontime >= 50 && ontime < 60) {
      if (this.state.drawNum >= 120000) {
        return true
      } else {
        this.setState({
          desc: this.state.lang.greaterThan(120000)
        })
        this.refs.toast.hideRule(true)
        return false
      }
    }

    if (ontime >= 60) {
      if (this.state.drawNum >= 20000) {
        return true
      } else {
        this.setState({
          desc: this.state.lang.greaterThan(20000)
        })
        this.refs.toast.hideRule(true)
        return false
      }
    }
  }

  // 兑换功能  有些人不能看到兑换按钮
  async onExchangeRuby() {
    // 条件1：NaN 和 0 情况
    if (this.state.changNum == 0 || isNaN(this.state.changNum)) {
      this.setState({
        desc: this.state.lang.pleaseEnter
      })
      this.refs.toast.hideRule(true)
      return
    }
    // 条件2：非500倍数
    if ((this.state.changNum%1) != 0 ) {
      let timeId = Math.round(new Date() / 1000)
      if (timeId<1701378000) {
        this.setState({
          desc: this.state.lang.erroGoldmsg
        })
      }else{
        this.setState({
          desc: this.state.lang.erromsg
        })
      }
      
      this.refs.toast.hideRule(true)
      return
    }
    // 获取值
    const num = this.state.changNum*2
    // 清空防止多次触发
    this.setState({
      exchangeNum: 0,
      changNum:0,
    })
    let res = await this.ruby.rubyExchange(parseInt(num))
    if (res && res.code == 77) {
      this.setState({
        desc: res.msg
      })
      this.refs.toast.hideRule(true)
      return
    }
    // console.log(1111, res)
    if (res) {
      // 用户宝石信息和列表，用于实时更新
      let info = await this.ruby.GetUserInfoWeb(this.state.uid)
      let rubyList = await this.ruby.rubyExchangeList()
      this.setState({
        rubyNum: info && info.ruby,
        receiveRubyToCoins: info && info.receiveRubyToCoins,
        freezeRuby: info && info.freezeRuby,
        isHostSystem: info && info.host,
        rubyList: rubyList && rubyList.list,
        desc: this.state.lang.exSuc,
        canEx: true,
        userRubyInfo: info, 
      })
      document.querySelector('.border-line').value = ''
      this.refs.toast.hideRule(true)
    }
  }

  // 提现功能
  async onWithdrawal() {
    // 条件1：NaN 和 0 情况
    if (this.state.drawNum == 0 || isNaN(this.state.drawNum)) {
      this.setState({
        desc: this.state.lang.pleaseEnter
      })
      this.refs.toast.hideRule(true)
      return
    }

    // 条件2：在线时长验证
    if (!this.gradeVerify()) {
      return
    }

    // 获取家族ID
    const fid = this.state.familyId
    // 获取族长ID
    const ownerId = this.state.familyLeaderInfo && this.state.familyLeaderInfo.uid
    // 用户提现接口
    const num = this.state.drawNum
    this.setState({
      drawNum: 0
    })
    let res = await this.ruby.onWithdrawal({
      familyId: fid,
      owner: ownerId,
      ruby: parseInt(num)
    })
    this.setState({
      drawNum: 0
    })

    document.querySelector('.input-num-draw').value = ''

    // 失败情况
    if (res.code != 0) {
      this.setState({
        desc: res && res.msg
      })
      this.refs.toast.hideRule(true)
      return
    }

    // 成功信息
    this.setState({
      desc: this.state.lang.applySuc
    })
    this.refs.toast.hideRule(true)
    // 刷新列表数据
    await this.initUserInfo()
    await this.initUserWithdrawalList()
  }

  // 家族族长提现处理
  async onHandleDraw() {
    // 族长审理提现
    let res = await this.ruby.onFamilyWithdrawal({
      images: [],
      id: this.state.handleDrawId || 0
    })
    console.log(res)
    this.setState({
      isHandle: false,
      desc: this.state.lang.handleSuc
    })
    this.refs.toast.hideRule(true)
    forbidScroll(false)

    // 以下操作是实时刷新族长处理后的列表展示，让用户可以固定在当前阶段继续操作，实时看到最新结果，并进行处理操作
    const scrollEnd = this.state.familyScroll.split(',')[0]
    let familyWithdrawalList = await this.ruby.familyWithdrawalList({
      familyId: this.state.familyId,
      scroll: `0,${scrollEnd}`
    })
    const list = familyWithdrawalList && familyWithdrawalList.res && familyWithdrawalList.res.list
    const more = familyWithdrawalList && familyWithdrawalList.res && familyWithdrawalList.res.hasMore
    this.setState({
      familyWithdrawalList: list,
      familyMore: more
    })
  }

  // 兑换金币列表（更多）
  async rubyMore() {
    try {
      this.setState({
        isLoading: true
      })
      const list = this.state.rubyList
      if (this.state.rubyMore && this.state.rubyScroll) {
        let rubyList = await this.ruby.rubyExchangeList(this.state.rubyScroll)
        console.log(rubyList)
        rubyList &&
          rubyList.list &&
          rubyList.list.map((item) => {
            list.push(item)
          })
        this.setState({
          rubyList: list,
          rubyMore: rubyList && rubyList.hasMore,
          rubyScroll: rubyList && rubyList.scroll
        })
      }
    } catch (error) {
      this.setState({
        desc: error
      })
      this.refs.toast.hideRule(true)
    } finally {
      this.setState({
        isLoading: false
      })
    }
  }

  // 加载提现列表（更多）// 只加载红宝石列表
  async onDrawMore() {
    try {
      this.setState({
        isLoadingDraw: true
      })
      // 原先列表
      let oldList = this.state.userWithdrawalList
      // 上一次是否更多
      const isMore = this.state.drawMore && this.state.drawScroll
      // 上一次参数
      const scrollParam = this.state.drawScroll
      if (isMore) {
        // 请求下一页
        let userWithdrawalList = await this.ruby.userWithdrawalList(scrollParam)
        // 拿到新的list列表
        const newList =
          userWithdrawalList && userWithdrawalList.res && userWithdrawalList.res.list && userWithdrawalList.res.list
        // 拿到下次的more和scroll
        const nextMoreParam = userWithdrawalList && userWithdrawalList.res && userWithdrawalList.res.hasMore
        const nextScrollParam = userWithdrawalList && userWithdrawalList.res && userWithdrawalList.res.scroll
        // 推入原先列表
        newList &&
          newList.map((item) => {
            oldList.push(item)
          })
        this.setState({
          userWithdrawalList: oldList,
          drawMore: nextMoreParam,
          drawScroll: nextScrollParam
        })
      }
    } catch (error) {
      this.setState({
        desc: error
      })
      this.refs.toast.hideRule(true)
    } finally {
      this.setState({
        isLoadingDraw: false
      })
    }
  }

  // 加载家族提现列表（更多）
  async onDrawMoreFamily() {
    try {
      this.setState({
        isLoadingDrawFamily: true
      })
      // 原先列表
      let oldList = this.state.familyWithdrawalList
      // 上一次是否更多
      const isMore = this.state.familyMore && this.state.familyScroll
      // 上一次参数
      const scrollParam = this.state.familyScroll
      if (isMore) {
        // 请求下一页
        let familyWithdrawalList = await this.ruby.familyWithdrawalList({
          scroll: scrollParam,
          familyId: this.state.familyId
        })
        // 拿到新的list列表
        const newList =
          familyWithdrawalList &&
          familyWithdrawalList.res &&
          familyWithdrawalList.res.list &&
          familyWithdrawalList.res.list
        // 拿到下次的more和scroll
        const nextMoreParam = familyWithdrawalList && familyWithdrawalList.res && familyWithdrawalList.res.hasMore
        const nextScrollParam = familyWithdrawalList && familyWithdrawalList.res && familyWithdrawalList.res.scroll
        // 推入原先列表
        newList &&
          newList.map((item) => {
            oldList.push(item)
          })
        this.setState({
          familyWithdrawalList: oldList,
          familyMore: nextMoreParam,
          familyScroll: nextScrollParam
        })
      }
    } catch (error) {
      this.setState({
        desc: error
      })
      this.refs.toast.hideRule(true)
    } finally {
      this.setState({
        isLoadingDrawFamily: false
      })
    }
  }

  // 规则内容组件
  contentComp(open, close, lang) {
    return (
      <div
        className="rule-content-box"
        onClick={() => {
          close()
        }}
      >
        <div className="title">{lang.rules}</div>
        <div className="content" dangerouslySetInnerHTML={{ __html: lang.ruleContent || '' }}></div>
      </div>
    )
  }
  changeNum = (e) => {
    let { receiveRubyToCoins,receiveRuby } = this.state
    if (e.target.value > receiveRubyToCoins) {
      this.setState({
        isShowTitle: true
      })
    } else {
      this.setState({
        isShowTitle: false,
        changNum: e.target.value / 2,
      })
    }
  }
  //转换
  handleExchange = ()=>{
    let {changNum,isShowTitle} = this.state
    if (changNum <= 0) return
    if (isShowTitle) return
    this.onExchangeRuby()
  }
  render() {
    let timeId = Math.round(new Date() / 1000)
    let { isShowTitle, changNum, receiveRubyToCoins, rubyList, lang, receiveRuby, rubyMore , isHostSystem, canChang } = this.state
    return (
      <div className="ruby-exchange">
         <Toast ref="toast" toastContent={this.state.desc} />
        <div className="ruby-exchange-top">
          <div className="top-title">{lang.exchange}</div>
          <ReminderBtn
            lang={lang}
            slotButtonComp={() => {
              return <div className="ruby-tab-item-tip"></div>
            }}
            slotContentComp={this.contentComp}
          />
        </div>
        {canChang && <div className="ruby-exchange-body">
          <div className="target">
            <div className="target-title">{lang.total}</div>
            <div className="target-num">{receiveRubyToCoins}</div>
          </div>
          {false && <div className="total">
            <div className="total-title">{lang.target}</div>
            <div className="total-num">{receiveRubyToCoins}</div>
          </div>}
          {canChang && <div className="exchange-amount">{lang.exchangeamount}</div>}
          {canChang && <div className="input-root">
            <input className="border-line" type="number" onChange={this.changeNum}></input>
          </div>}
          {canChang && !isShowTitle && (
            <div className="will-get">
              <div className="will-get-title">{lang.willget} :</div>
              {timeId >= 1701378000 && <img className="will-get-img" src="/img/app/ruby/icon_ruby_.png"></img>}
              {timeId  < 1701378000 && <img className="will-get-img" style={{height:'0.24rem'}} src="/img/app/ruby/icon_coin_gold-new.png"></img>}
              <div className="get-num">{changNum}</div>
            </div>
          )}
          {canChang && isShowTitle && (
            <div className="will-get">
              <div className="will-get-title">{lang.notenough}</div>
            </div>
          )}
         {canChang && <div className="btn-exchange" style={{color:changNum && !isShowTitle?'#FF6684':''}} onClick={this.handleExchange}>{lang.exchange}</div>}
        </div>}
        {!canChang && <div className='no-exchange-man'>{lang.noChangeMan}</div>}
        <div className="ruby-exchange-footer">
          {rubyList && rubyList.map((item, index) => (
            <div className="change-list-item" key={index}>
              <div className="item-left">
                <div className="left-top">Exchange: {item.ruby}</div>
                <div className="left-buttom">{item.ts}</div>
              </div>
              <div className="item-rigth">
               { item.rtype == 13 && <img className="rigth-img" src="/img/app/ruby/icon_ruby_get.png"></img>}
               { item.rtype == 5 && <img className="rigth-img" style={{height:'0.32rem'}} src="/img/app/ruby/icon_coin_gold-new.png"></img>}
                <div className="right-rigth">+{item.gold}</div>
              </div>
            </div>
          ))}

          { rubyMore &&
            <div
              className="more"
              onClick={() => {
                this.rubyMore()
              }}
            >
              {this.state.lang.more}
            </div>
          }
          {!rubyList && (<div className='record-is-empty'>
             <img className='empty-img' src='/img/app/ruby/ruby-record-empty.png'></img>
             <div className='empty-title'>{lang.emptyText}</div>
          </div>)}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/ruby/index.js